module.exports = __webpack_public_path__ + "static/media/eraser.8796960d.svg";